import {ElementRef, Component, OnDestroy} from '@angular/core'
import {ActivatedRoute} from '@angular/router'

import {CustomGridFilterModule, SharedMethodsModule} from '../../insa-custom-scripts'
import {RiskAssessmentService, LocalizeService, InsaService, AuthService} from '../../insa-services'
import {appStateProvider} from '../../insa-providers'
import {Translations,
        Language,
        GivenAnswer,
        RiskProfileStrategy,
        CategoryPoints,
        QuestionChoice,
        RiskProfileModel,
        RiskProfileCategory,
        RiskProfileQuestionsModel,
        RiskProfileAssessmentModel,
        RiskAssesmentDataModel,
        RiskProfileDataModel,
        Translation,
        KendoColumnDefinition} from '../../insa-models'
import { assessmentViewModes, viewStates, questionTypes, editModes } from '../insa-risk-assessment/riskAssessment.enums'
import './riskAssessment.component.css'

let cloneDeep = require('lodash.clonedeep');
let gridColumnReorder = window['gridColumnReorder'];
let KendoGridDataBound = window['KendoGridDataBound'];

@Component({
    selector: 'risk-assessment',
    templateUrl: "riskAssessment.component.html",
    //styleUrls: require('./riskAssessment.component.css')
})
export class RiskAssessmentComponent implements OnDestroy { 
    private assessmentViewModes = assessmentViewModes;
    private assessmentViewMode : assessmentViewModes = assessmentViewModes.LIST; 
    private showAdminStuff : boolean = false;
    private DEFAULT_LANGUAGE : number = 2;
    private viewStates = viewStates;
    private questionTypes = questionTypes;
    private editModes = editModes;
    private viewState : viewStates = viewStates.UNDEFINED;
    private selectedProfileIndex : number = undefined;
    private editMode : editModes = editModes.UNDEFINED;
    private editedResult : RiskProfileAssessmentModel = undefined;
    private editedStrategies : RiskProfileStrategy [] = [];
    private editedProfileTitle: Translations = [];
    private selectedQuestionIndex = undefined;
    private selectedResultId : number = undefined;
    private questionData : RiskProfileQuestionsModel [] = [];
    private riskProfiles : RiskProfileModel [] = [];
    private availableCategories : RiskProfileCategory [] = [];
    private riskAssessmentSubscription;
    private riskAssessmentQuestionsSubscription;
    private stateSubscription;
    private selectedPartner = { value: 0, text: "" };
    private routePartner = { value: undefined, text: "" };
    private newChoice : QuestionChoice;
    private newCategory: string;
    private newStrategy: RiskProfileStrategy;
    private pdfEvent;
    private languages: Language[] = [];
    private prioritizedLanguages: Language[] = [];
    private selectedLanguageIndex: number = undefined;
    private userHasInsaUserRole: boolean;
    
    constructor(private _insaService: InsaService, private _riskService: RiskAssessmentService,private _appStateProvider: appStateProvider, private _authService: AuthService, private route: ActivatedRoute, private _element: ElementRef, private _localize: LocalizeService) {
        this.userHasInsaUserRole = this._authService.roles.indexOf("InsaUser") >= 0;
        this.showAdminStuff = this.userHasInsaUserRole;        
        // IMPORTANT:
        // If a partner is defined in route, it has higher priority than appState value!
        // This is for use case of embedding Risk Profiler in Desktop INSA
        let routeSnapshot = route.snapshot;
        this.routePartner = {
            value: routeSnapshot.queryParamMap.has('partnerValue') ? parseInt(routeSnapshot.queryParamMap.get('partnerValue')) : undefined,
            text: routeSnapshot.queryParamMap.has('partnerText') ? routeSnapshot.queryParamMap.get('partnerText') : undefined
        };
        // console.log(this.selectedPartner);
        // first load languages, then initialize
        this._insaService.getLanguages().then((data: Language[]) => {
            this.languages = data;            
            this.pdfEvent = _riskService.getRiskProfilePdfEvent;
            this.pdfEvent.subscribe(() => {
                kendo.ui.progress($('.riskProfileLoading'), false);                        
            })
            this.stateSubscription = _appStateProvider.subscribe(eventdata => {
                // let loading = this._appStateProvider.fetchingRiskProfileQuestions || this._appStateProvider.fetchingRiskProfiles            
                this.initDataFetching(eventdata);
            });
            this.riskAssessmentSubscription = this._riskService.RiskProfilesEvent.subscribe(riskAssessementResults => {
                this.initVars();
                this.riskProfiles = riskAssessementResults;
                if (this.riskProfiles.length > 0) {
                    this.selectProfile(0);
                }
                kendo.ui.progress($('.riskProfileLoading'), false);                
            });
            this.riskAssessmentQuestionsSubscription = this._riskService.RiskProfileAssessmentQuestionsEvent.subscribe(questions => {
                this.questionData = questions || [];
                kendo.ui.progress($('.riskProfileLoading'), false);                
            });
        }).catch(e => {
            console.log('ERROR!');
            console.log(e);
        });
    }   

    ngAfterViewInit () {
        this._localize.applyTranslations(this._element.nativeElement);
    }

    initVars () {
        // TODO: assuming languages are loaded before everything else!
        // this.prioritizedLanguages = cloneDeep(this.languages);
        // this.prioritizedLanguages.sort((a,b) => a.Priority < b.Priority ? 1 : a.Priority > b.Priority ? -1 : 0);
        this.selectedProfileIndex = undefined;
        this.selectedQuestionIndex = undefined;
        this.questionData = [];
        this.selectedResultId = undefined;
        this.riskProfiles = [];
        this.editMode = editModes.UNDEFINED;  
        this.editedResult = undefined;
        this.editedStrategies = undefined; 
        this.editedProfileTitle = this.languages.map(lang => {
            return {
                LanguageId: lang.Id,
                Text: ''
            }
        });
        this.selectedLanguageIndex = this.languages.length > 0 ? 0 : undefined;                    
    }

    initDataFetching (eventdata, alwaysFetch = false) {
        // IMPORTANT:
        // If a partner is defined in route, it has higher priority than appState value!
        // This is for use case of embedding Risk Profiler in Desktop INSA)
        let appStatePartner = this._appStateProvider.selectedPartner;
        let usePartner = this.routePartner.value !== undefined ? this.routePartner : appStatePartner;
        // re-initialize only when partner changes or when you need!
        if (this.selectedPartner.value !== usePartner.value || alwaysFetch) {
            this.selectedPartner = usePartner;
            if (this.selectedPartner.value) {
                kendo.ui.progress($('.riskProfileLoading'), true);                        
                this.initVars();
                this._riskService.getRiskProfiles();
                this.changeViewState(viewStates.DASHBOARD);                    
            } else {
                this.changeViewState(viewStates.UNDEFINED);
            }
        }
    }

    ngOnInit () {
        this.initDataFetching({});
    }

    ngOnDestroy(){
        if (this.stateSubscription) {
            this.stateSubscription.unsubscribe();            
        }
        if (this.riskAssessmentSubscription) {
            this.riskAssessmentSubscription.unsubscribe();            
        }
        if (this.riskAssessmentQuestionsSubscription) {
            this.riskAssessmentQuestionsSubscription.unsubscribe();            
        }
    }

    selectLanguage (index) {
        this.selectedLanguageIndex = index;
        if (this.editMode === editModes.ADMIN) {
            this.fillOtherLanguages(this.selectedQuestionIndex);
        }
        if (this.editMode === editModes.EDIT) {
            this.fillOtherAnswers(this.selectedQuestionIndex);
        }
    }

    printRiskProfile () {
        switch (this.editMode) {
            case editModes.NEW:
                this.printEmptyRiskProfile(this.selectedProfileIndex);
                break;            
            case editModes.EDIT:
                this.printAssessment(this.selectedProfileIndex, this.editedResult.Id);
                break;
            default:
                this.printEmptyRiskProfile(this.selectedProfileIndex);
                break;
        }
    }

    printEmptyRiskProfile (riskProfileIndex) {
        kendo.ui.progress($('.riskProfileLoading'), true);                
        this._riskService.getRiskProfilePDF(this.riskProfiles[riskProfileIndex].Id, undefined, this.languages[this.selectedLanguageIndex].Id)
        this.changeViewState(viewStates.PRINT);
    }    

    printAssessment (riskProfileIndex, assessmentId) {
        // save before PDF creation!
        kendo.ui.progress($('.riskProfileLoading'), true);        
        return this.saveEditedResult().then(() => {
            this._riskService.getRiskProfilePDF(this.riskProfiles[riskProfileIndex].Id, assessmentId, this.languages[this.selectedLanguageIndex].Id);
            this.changeViewState(viewStates.PRINT);               
        });          
    }    

    private refreshGrid () {
      let grid = $("#selectedProfileGrid").data("kendoGrid");
      let groups
      if (grid) {
        groups = grid.dataSource['_group'];
      }
      $('#selectedProfileGrid').removeData('kendoGrid');
      $('#selectedProfileGrid').empty();
      if (this.selectedProfileIndex > -1) {
          let dataSource = this.prepareDataSource(this.riskProfiles[this.selectedProfileIndex])
          let columnDefs = this.createGridColumnDef(this.riskProfiles[this.selectedProfileIndex])
          this.initGrid(columnDefs, dataSource);
          this.selectedResultId = undefined;
          // restore grouping
          let grid2 = $("#selectedProfileGrid").data("kendoGrid");
          if (grid2 && groups) {
            let filteredGroups = groups.filter(g => grid2.columns.some(col => col.field === g.field))
            grid2.dataSource.group(filteredGroups);
          }
          // reselect if there was something
          // TODO: doesn't work!
          // --->
          // let grid = $("#selectedProfileGrid").data("kendoGrid");
          // let rows = grid.dataSource.data();
          // console.log(this.selectedResultId)
          // let row = rows.find(r => r['Id'] === this.selectedResultId);
          // console.log(row)
          // grid.select(row);
      }
    }

    private createGridColumnDef(riskProfile: RiskProfileModel) {
        let  gridColumnDef = new Array<KendoColumnDefinition>();
        gridColumnDef.push(new KendoColumnDefinition('Id', 'Id', '#:(Id!==null) ? Id : "" #', '', true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 100));
        riskProfile.Categories.forEach(category => {
          let field = 'Category' + category.Id
          let template = `#:(${field}!==null) ? ${field} : "" #`
          // ne treba mi kolona za naziv
          // gridColumnDef.push(new KendoColumnDefinition(field, category.category, template));
          let template2 = `#:(${field}_recommendation!==null) ? ${field}_recommendation : "" #`
          gridColumnDef.push(new KendoColumnDefinition(field + '_recommendation', 'Suggested ' + category.Category, template2, '', true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 300));
          let template3 = `#:(${field}_points!==null) ? kendo.toString(${field}_points, "n0") : "" #`
          gridColumnDef.push(new KendoColumnDefinition(field + '_points', category.Category + ' Points', template3, '', true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 300));
          let template4 = `#:(${field}_chosen!==null) ? ${field}_chosen : "" #`
          gridColumnDef.push(new KendoColumnDefinition(field + '_chosen', 'Chosen ' + category.Category, template4, '', true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 300));
        });
        gridColumnDef.push(new KendoColumnDefinition('ExpectedCapital', 'Expected Capital', '#:(ExpectedCapital!==null) ?  kendo.toString(ExpectedCapital, "n2") : "" #', '{0:#.##}', true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 200));
        gridColumnDef.push(new KendoColumnDefinition('CreateDate', 'Created', '#:(CreateDate!==null) ? kendo.toString(CreateDate, "dd.MM.yyyy") : "" #', '', true));
        gridColumnDef.push(new KendoColumnDefinition('Creator', 'Creator', '#:(Creator!==null) ? Creator : "" #', '', true));
        // template uses icon instead of value!
        gridColumnDef.push(new KendoColumnDefinition('Frozen', 'Frozen', `<i class="glyphicon glyphicon-#:Frozen ? "ok" : "remove" #"></i>`, '', true));
        return gridColumnDef;
    }

    initGrid (columnDefs, gridSource) {
        let dataSourceOptions: kendo.data.DataSourceOptions = {};
        dataSourceOptions.data = gridSource.data;
        dataSourceOptions.schema = gridSource.schema;
        let dataSource: kendo.data.DataSource = new kendo.data.DataSource(dataSourceOptions);
        let kendoGrid: kendo.ui.Grid = $('#selectedProfileGrid').data('kendoGrid');
        // buttoni za toolbar
        let freezeButton: kendo.ui.GridToolbarItem = {
            name: 'freeze',
            template: '<a id="freezeButton" class="customButton hidden k-button k-button-icontext"><i class="glyphicon glyphicon-asterisk"></i><span id="frozenText"></span></a>',
            text: 'Freeze'
        };
        let newButton: kendo.ui.GridToolbarItem = {
            name: 'new',
            template: '<a id="newButton" class="customButton k-button k-button-icontext"><i class="glyphicon glyphicon-plus"></i>New</a>',
            text: 'New'
        };
        let cloneButton: kendo.ui.GridToolbarItem = {
            name: 'clone',
            template: '<a id="cloneButton" class="customButton hidden k-button k-button-icontext"><i class="glyphicon glyphicon-duplicate"></i>Duplicate</a>',
            text: 'Duplicate'
        };
        let editButton: kendo.ui.GridToolbarItem = {
            name: 'edit',
            template: '<a id="editButton" class="customButton hidden k-button k-button-icontext"><i class="glyphicon glyphicon-edit"></i><span id="editButtonText">Edit</span></a>',
            text: 'Edit'
        };
        let changeStrategyButton: kendo.ui.GridToolbarItem = {
            name: 'changeStrategy',
            template: `<a id="changeStrategyButton" data-toggle="modal" data-target="\\#changeStrategyDialog" class="customButton hidden k-button k-button-icontext"><i class="glyphicon glyphicon-random"></i>Change Strategy</a>`,
            text: 'Change Strategy'
        };
        let deleteButton: kendo.ui.GridToolbarItem = {
            name: 'delete',
            template: '<a id="deleteButton" data-toggle="modal" data-target="\\#confirmDeleteAssessmentDialog" class="customButton hidden k-button k-button-icontext"><i class="glyphicon glyphicon-trash"></i>Delete</a>',
            text: 'Delete'
        }
        // TODO: check if some of the options do not make sense...
        if (kendoGrid === undefined ) {
            let gridOptions: kendo.ui.GridOptions = {};
            gridOptions.dataSource = dataSource;
            gridOptions.filterable = true;
            gridOptions.height = '100%';
            gridOptions.sortable = true;
            gridOptions.toolbar = [newButton, cloneButton, editButton, freezeButton, changeStrategyButton, deleteButton];
            // gridOptions.excel = {
            //     fileName: this.riskProfiles[this.selectedProfileIndex].Title + ".xlsx",
            //     filterable:true,
            //     allPages: true
            // };
            gridOptions.selectable = true;
            gridOptions.reorderable = true;
            gridOptions.scrollable = true;
            gridOptions.noRecords = { template: SharedMethodsModule.noDataTemplate() };
            gridOptions.pageable = false;
            if(window.innerWidth > 768){
             gridOptions.filterMenuInit = CustomGridFilterModule.onFilterMenuInit;
            }
            gridOptions.groupable = true;
            gridOptions.resizable = true;
            gridOptions.columns = columnDefs;
            gridOptions.columnReorder = gridColumnReorder;
            gridOptions.dataBound = KendoGridDataBound;
            // set dbl click on all rows - set which resultId is selected
            let vm = this;
            gridOptions.dataBound = function (e) {
                let grid = this;
                grid.tbody.find("tr").dblclick(function (e) {
                    let dataItem = grid.dataItem(this);
                    vm.editAssessment(dataItem.Id);
                });
                grid.tbody.find("tr").click(function (e) {
                    // first hide all
                    ['#freezeButton', '#editButton', '#changeStrategyButton', '#deleteButton'].forEach(selector => {
                        $(selector).addClass('hidden');
                    });
                    let dataItem = grid.dataItem(this);
                    vm.selectedResultId = dataItem.Id
                    let res = vm.getResultById(vm.selectedResultId)
                    // console.log(res)
                    $('#frozenText').text(res ? (res.Frozen ? 'N/A' : 'FREEZE') : '');
                    $('#editButtonText').text(res ? (res.Frozen ? 'View' : 'Edit') : '');
                    // choose which buttons get shown
                    if (!res.Frozen) {
                        ['#freezeButton', '#changeStrategyButton', '#deleteButton'].forEach(selector => {
                            $(selector).removeClass('hidden');
                        });
                    }
                    // these buttons always get shown
                    // editButton -> within assessment we check for Frozen flag and prevent change
                    ['#editButton', '#cloneButton'].forEach(selector => {
                        $(selector).removeClass('hidden');
                    });
                });
                $('#freezeButton').click(e => {
                    vm.setFrozen(vm.selectedResultId);
                });
                $('#newButton').click(e => {
                    vm.newAssessment(vm.selectedProfileIndex);
                });
                $('#cloneButton').click(e => {
                    vm.newAssessment(vm.selectedProfileIndex, vm.selectedResultId);
                });
                $('#editButton').click(e => {
                    vm.editAssessment(vm.selectedResultId);
                });
                $('#changeStrategyButton').click(e => {
                    vm.showChangeStrategyDialog(vm.selectedResultId);
                });
                $('#deleteButton').click(e => {
                    vm.showDeleteAssessmentDialog(vm.selectedResultId);
                });
            };
            $('#selectedProfileGrid').kendoGrid(gridOptions);
            kendoGrid = $('#selectedProfileGrid').data('kendoGrid');
        }
        else {
            kendoGrid.setDataSource(dataSource);
        }
    }

    selectProfile (ix) {
        this.selectedProfileIndex = ix;
        this.refreshGrid();
    }

    changeViewState (viewState) {
        this.viewState = viewState;
        // fix ngIf destruction of elements after doing questions
        if (viewState === viewStates.DASHBOARD) {
            setTimeout(()=>{
                this.selectProfile(this.selectedProfileIndex);
            }, 0);
        }
        if (viewState === viewStates.ASSESSMENT) {
            // switch to language used in assessment
            let usedLanguage = this.languages.findIndex(lang => lang.Id === this.editedResult.Language);
            this.selectedLanguageIndex = usedLanguage === -1 ? this.selectedLanguageIndex : usedLanguage;
            if (this.editMode === editModes.ADMIN) {
                this.assessmentViewMode = assessmentViewModes.SEQUENTIAL;
            } else {
                this.assessmentViewMode = assessmentViewModes.LIST;
            }
        }
    }

    loadQuestions (riskProfileId, resultId = null) {
        kendo.ui.progress($('.riskProfileLoading'), true);
        return this._riskService.getRiskAssessmentQuestions(riskProfileId, resultId);
    }

    addAnswer () {
        let nc:QuestionChoice = cloneDeep(this.newChoice);
        this.questionData[this.selectedQuestionIndex].Choices.push(nc);
        this.prepareNewChoice();
    }

    removeAnswer (choiceIndex) {
        this.questionData[this.selectedQuestionIndex].Choices.splice(choiceIndex, 1);
    }

    prepareNewStrategy () {
        let ps : Array<CategoryPoints> = [];
        this.editedResult.Categories.forEach(c => {
            ps.push({
              CategoryId: c.Id,
              Points: 0,
              MaxPoints: 0
            });
        }); 

        let st: Translations = this.languages.map(lang => {
            return {
                LanguageId: lang.Id,
                Text: ''
            }
        })
        this.newStrategy = {
            Id: null,
            EquityAllocation: 0,
            Strategy: st,
            Points: ps,
            Description: cloneDeep(st)
        }        
    }

    editStrategies () {             
        this.changeViewState(viewStates.EDIT_STRATEGIES);
    }   

    saveStrategyRules () {
        this.changeViewState(viewStates.ASSESSMENT);
        // saving actually happens together with saving questions and all stuff
    }   

    editRiskProfile (ix) {
        this.selectProfile(ix);
        return this.prepareNewQuestions().then(data => {
            this.prepareNewChoice();
            this.prepareNewStrategy();
            this.editedProfileTitle = this.riskProfiles[this.selectedProfileIndex].Title;
            this.editedStrategies = cloneDeep(this.riskProfiles[this.selectedProfileIndex].Strategies);     
            this.newCategory = '';
            this.editMode = editModes.ADMIN;                
            this.changeViewState(viewStates.ASSESSMENT);    
            return data
        });

    }

    newAssessment (ix, cloneIndex  = null) {
        this.selectProfile(ix);
        return this.prepareNewQuestions(cloneIndex).then(data => {
            this.editMode = editModes.NEW;
            this.calculatePoints();
            this.changeViewState(viewStates.ASSESSMENT);    
            return data
        });
    }

    editDefaultAssessmentForProfile (profileIndex) {
        if (this.riskProfiles[profileIndex].Assessments.length > 0) {
            this.editAssessment(this.riskProfiles[profileIndex].Assessments[0].Id);
        } else {
            this.newAssessment(profileIndex);
        }
    }

    editAssessment (resultId) {  
        // this doubles as VIEW button for frozen assessments  
        // if (!this.getResultById(resultId).Frozen) {
            this.editedResult = cloneDeep(this.getResultById(resultId));  
            this.selectedQuestionIndex = 0;
            this.editMode = editModes.EDIT;
            return this.loadQuestions(this.riskProfiles[this.selectedProfileIndex].Id, this.editedResult.Id).then(data => {
                this.changeViewState(viewStates.ASSESSMENT);
                return data;
            });    
        // };
    }

    cancelAssessment () {
        // cleanup and change view
        this.editMode = editModes.UNDEFINED;
        this.questionData = [];
        this.editedResult = undefined;
        this.editedStrategies = undefined;
        this.changeViewState(viewStates.DASHBOARD);
        kendo.ui.progress($('.riskProfileLoading'), false);
    }

    saveAssessment () {
        kendo.ui.progress($('.riskProfileLoading'), true);
        // save if not frozen!
        if (this.editedResult.Frozen) {
            this.cancelAssessment();
            return Promise.resolve();
        }
        // save the last used language
        this.editedResult.Language = this.languages[this.selectedLanguageIndex].Id;
        if (this.editMode === editModes.NEW) {
            let riskAssesmentData :  RiskAssesmentDataModel = {
                riskProfileId: this.riskProfiles[this.selectedProfileIndex].Id,
                assessment: this.editedResult,
                questions: this.questionData
            }
            return this._riskService.addRiskAssessment(riskAssesmentData).then(data => {
                // newly created record is in the body as the single assessment of only profile
                let rec:RiskProfileModel = JSON.parse(data['_body'])[0];
                // console.log(rec);
                this.riskProfiles[this.selectedProfileIndex].Assessments.unshift(rec.Assessments[0]);
                this.riskProfiles[this.selectedProfileIndex].CanEdit = false;
                this.refreshGrid();
            }).then(() => {
                // cleanup and go to dashboard
                this.cancelAssessment();
            });
        }    
        if (this.editMode === editModes.EDIT) {
            return this.saveEditedResult().then(() => {
                // cleanup and go to dashboard
                this.cancelAssessment();
            });            
        }
        if (this.editMode === editModes.ADMIN) {
            return this.saveRiskProfile().then(() => {
                // cleanup and go to dashboard
                this.cancelAssessment();
            })
        }
    }

    deleteRiskProfile (ix) {
        let id = this.riskProfiles[ix].Id;
        return this._riskService.deleteRiskProfile(id).then(data => {
            // force reload all data
            this.initDataFetching({}, true);
        });        
    }

    enterNewRiskProfile () {
        let nt: Translations = this.languages.map(lang => {
            return {
                LanguageId: lang.Id,
                Text: 'New Risk Profile'
            };
        });
        this.editedProfileTitle = nt;
    }

    saveNewRiskProfile () {
        let rp : RiskProfileModel = {
            Title: this.editedProfileTitle,
            CreateDate: new Date(),
            CreatorId: -1, // this._authService.UserInfo.
            Creator: this._authService.UserInfo.Name,
            Assessments: null,
            CanEdit: true,
            Categories: null,
            Id: null,
            Strategies: null
        };
        return this._riskService.createRiskProfile(rp).then(data => {
            // force reload all data
            this.initDataFetching({}, true);
        });
    }

    saveRiskProfile () {
        this.fillOtherLanguages(this.selectedQuestionIndex);
        // ignore assessments, but take categories from editedResult
        let prof : RiskProfileModel = {
            Id : this.riskProfiles[this.selectedProfileIndex].Id,
            Categories : this.editedResult.Categories,
            Title : this.editedProfileTitle,
            Assessments : null,
            Strategies : this.editedStrategies,
            CanEdit : true,
            CreateDate: this.riskProfiles[this.selectedProfileIndex].CreateDate,
            Creator: this.riskProfiles[this.selectedProfileIndex].Creator,
            CreatorId: this.riskProfiles[this.selectedProfileIndex].CreatorId
        }
        let profData : RiskProfileDataModel = {
            riskProfile: prof,
            questions: this.questionData
        }
        return this._riskService.updateRiskProfile(profData).then(data => {
            // force reload all data
            this.initDataFetching({}, true);
        });
    }    

    checkboxAnswerClick (choiceId, sqIndex = this.selectedQuestionIndex) {
        let mcal = this.questionData[sqIndex].Answer.MultipleChoiceAnswerList || '';
        // empty string should result in empty array --> otherwise split gets to be [''] and first Id in list is NaN
        let currentAnswerList = mcal.trim() === '' ? [] : mcal.trim().split(',').map(m => parseInt(m));
        let foundIx = currentAnswerList.findIndex(a => a === choiceId);
        if (foundIx > -1) {
            currentAnswerList.splice(foundIx, 1);
        } else {
            currentAnswerList.push(choiceId);
        }
        this.questionData[sqIndex].Answer.MultipleChoiceAnswerList = currentAnswerList.join(',');
        // update choiceId to the one with max points
        // TODO: we take the choiceId with maximum of all points summarized for all categories
        let maxChoice = this.questionData[sqIndex].Choices.filter(c => currentAnswerList.some(a => c.Id === a)).reduce((max, curr) => (max && curr.Points.reduce((sum, p) => sum + p.Points, 0) < max.Points.reduce((sum, p) => sum + p.Points, 0)) ? max : curr, undefined);
        this.questionData[sqIndex].Answer.ChoiceId = maxChoice ? maxChoice.Id : undefined;
        this.calculatePoints();
    }

    questionHasCheckbox (choiceId, sqIndex = this.selectedQuestionIndex) {
        let mcal = this.questionData[sqIndex].Answer.MultipleChoiceAnswerList || '';
        return mcal.trim().split(',').map(m => parseInt(m)).some(m => m === choiceId);
    }

    calculatePoints () {
        // console.log('calculatePoints')
        // setTimeout is here to let angular process the new binding values when clicking on e.g. radio buttons
        // otherwise we get old selected choices
        setTimeout(() => {
            // clear the currently assigned points
            this.editedResult.Categories.forEach(c => {
                c.Points = 0;
            })
            // go through all questions
            this.questionData.forEach(q => {
                switch (q.QuestionType) {
                    case questionTypes.MULTIPLE_CHOICE:
                    case questionTypes.MULTIPLE_CHOICE_AND_TEXT:
                        // find the original choice based on given answer Id
                        let choice = q.Choices.find(ga => ga.Id === q.Answer.ChoiceId)
                        if (choice) {
                            // assign points to all categories in the editedResult object
                            choice.Points.forEach(cp => {
                                let editCategory = this.editedResult.Categories.find(ecp => ecp.Id === cp.CategoryId)
                                if (editCategory) {
                                    editCategory.Points += cp.Points                               
                                }
                            });
                        }
                        break;
                    case questionTypes.TEXT_ONLY:
                        break;
                    case questionTypes.UNDEFINED:
                        break;
                    default:
                        break;
                }
            })
            // with total points calculated per category, find strategies
            let expectedCapital = 0;
            this.editedResult.Categories.forEach(cat => {
                 let xc = this.riskProfiles[this.selectedProfileIndex].Strategies.find(s => {
                     let sp = s.Points.find(p => {
                         let z = p.CategoryId == cat.Id && p.Points <= cat.Points && cat.Points <= p.MaxPoints && (p.Points !== 0 || p.MaxPoints !== 0)
                         return z;
                    })
                    return sp !== undefined
                 })
                 if (xc) {
                     cat.RecommendedStrategy = xc;
                     expectedCapital += xc.EquityAllocation; // TODO: validate assumption!
                 } else {
                     let st: Translations = this.languages.map(lang => {
                         return {
                             LanguageId: lang.Id,
                             Text: ''
                         };
                     });
                     cat.RecommendedStrategy = {
                         Id: null,
                         EquityAllocation: null,
                         Points: null,
                         Strategy: st,
                         Description: cloneDeep(st)
                     }
                 }
            })
            this.editedResult.ExpectedCapital = expectedCapital;
        }, 0);
    }

    prepareNewQuestions(cloneIndex = null) {
        this.selectedQuestionIndex = undefined;
        this.questionData = [];
        // select questions and answer structure into questionData
        return this.loadQuestions(this.riskProfiles[this.selectedProfileIndex].Id, cloneIndex).then((data: any) => { //holi
            // prepare new result
            let assessment : RiskProfileAssessmentModel = {
                Id: null,
                Categories: cloneDeep(this.riskProfiles[this.selectedProfileIndex].Categories),
                CreateDate: new Date(),
                Creator: this._authService.UserInfo.Name,
                ExpectedCapital: null,
                Frozen: false,
                Language: this.DEFAULT_LANGUAGE,
                // TODO: define them otherwise results do not show up in INSA
                PartnerIndex: this.selectedPartner.value,
                PartnerNumber: this.selectedPartner.text 
            } 
            this.editedResult = assessment;
            if (data.length > 0) {
                this.selectedQuestionIndex = 0;                
            }
            return data;
        });
    }

    addCategory () {
        // prevent adding category when there is already one
        // this would imply the need to update all results now!
        if (!this.riskProfiles[this.selectedProfileIndex].CanEdit) {
            return;
        }
        // add to categories
        let st: Translations = this.languages.map(lang => {
            return {
                LanguageId: lang.Id,
                Text: ''
            };
        });        
        let newCat : RiskProfileCategory = {
            Category: this.newCategory,
            Id: this.editedResult.Categories.length + 1,
            RecommendedStrategy: null,
            ChosenStrategy: null,
            MaxPoints: 0,
            Points: 0            
        };
        let cp : CategoryPoints = {
            CategoryId: newCat.Id,
            Points: 0,
            MaxPoints: 0
        };
        this.newCategory = '';
        this.editedResult.Categories.push(newCat);
        // add to all questions and all choices
        this.questionData.forEach(q => {
            q.Choices.forEach(c => {
                c.Points.push(cloneDeep(cp));
            });
        });
        // add to strategies
        this.editedStrategies.forEach(s => {
            let scp : CategoryPoints = {
                CategoryId: newCat.Id,
                Points: 0,
                MaxPoints: 0
            };            
            s.Points.push(cloneDeep(scp));
        })
        // refresh new choice
        this.prepareNewChoice();
        this.prepareNewStrategy();
    }

    removeCategory (category: RiskProfileCategory) {
        // prevent removing category when there is already one
        // this would imply the need to update all results now!      
        if (!this.riskProfiles[this.selectedProfileIndex].CanEdit) {
            return;
        }
        // save Id of Category to be removed
        let id = category.Id
        // update Ids for all subsequent categories to be Id-1, so we have again 1, 2
        this.editedResult.Categories.filter(c => c.Id > id).forEach(c => c.Id = c.Id - 1);            
        // Ids are always  1, 2, 3 so I can just use it as index
        this.editedResult.Categories.splice(id - 1, 1);            

        // remove from questions
        this.questionData.forEach(q => {
            q.Choices.forEach(c => {
                c.Points.splice(id - 1, 1);
            })
            q.Answer.ChoiceId = null; // TODO: do something better? It shouldn't be filled anyway in design mode
        })
        // remove from strategies
        this.editedStrategies.forEach(s => {
            s.Points.splice(id - 1, 1);
            // update Ids for all subsequent categories to be Id-1, so we have again 1, 2
            s.Points.filter(c => c.CategoryId > id).forEach(c => c.CategoryId = c.CategoryId - 1);
        })
        // refresh new choice
        this.prepareNewChoice();
        this.prepareNewStrategy();
    }

    prepareDataSource (riskProfile: RiskProfileModel) {
      let data = []
      let schema = {
          model: {
              fields: {
                  Id: { type: 'number' },
                  CreateDate: { type: 'date' },
                  Creator: { type: 'string' },
                  Frozen: { type: 'boolean' },
                  ExpectedCapital: { type: 'number' }
              }
          }
      }
      riskProfile.Categories.forEach(category => {
        // schema
        let schemaFields = {}
        let field = 'Category' + category.Id;
        schemaFields[field] = { type: 'string' };
        schemaFields[field + '_recommendation'] = { type: 'string' };
        schemaFields[field + '_points'] = { type: 'number' };
        schemaFields[field + '_chosen'] = { type: 'string' };
        schemaFields[field + '_maxPoints'] = { type: 'number' };
        Object.assign(schema.model.fields, schemaFields);
      })
      riskProfile.Assessments.forEach(res => {
          let newRecord = {
              Id: res.Id,
              CreateDate: res.CreateDate,
              Creator: res.Creator,
              Frozen: res.Frozen,
              ExpectedCapital: res.ExpectedCapital
          }
          // flattten categories into record
          res.Categories.forEach(category => {
              // fields
              let field = 'Category' + category.Id;
              newRecord[field] = category.Category;
              newRecord[field + '_recommendation'] = category.RecommendedStrategy.Strategy[this.selectedLanguageIndex].Text;
              newRecord[field + '_points'] = category.Points;
              newRecord[field + '_chosen'] = category.ChosenStrategy.Strategy[this.selectedLanguageIndex].Text;
              newRecord[field + '_maxPoints'] = category.MaxPoints;
          })
          data.push(newRecord);
      })
      return {data: data, schema: schema}
    }

    prepareNewChoice () {
        let ps : Array<CategoryPoints> = [];
        this.editedResult.Categories.forEach(c => {
            ps.push({
              CategoryId: c.Id,
              Points: 0,
              MaxPoints: 0
            });
        }); 
        let na = this.languages.map(lang => {
            return {
                LanguageId: lang.Id,
                Text: ''
            };
        });
        this.newChoice = {
          Id: null,
          Answer: na,
          Points: ps 
        };
    }

    prevQuestion () {
        if (this.editMode === editModes.ADMIN) {
            this.fillOtherLanguages(this.selectedQuestionIndex);
        }
        if (this.selectedQuestionIndex > 0) {
            this.fillOtherAnswers(this.selectedQuestionIndex);
            this.selectedQuestionIndex--;
            this.prepareNewChoice();
            this.calculatePoints();            
        }
    }

    removeQuestion (questionIndex) {
        let le = this.questionData.length;
        this.questionData.splice(questionIndex, 1);
        // if it was last question
        if (questionIndex === le - 1) {
            questionIndex--;
            if (le === 1) {
                questionIndex = undefined;
            }
        }
        this.selectedQuestionIndex = questionIndex;        
    }

    addQuestionAfter (questionIndex) {
        if (questionIndex === undefined) {
            // add to end if undefined
            questionIndex = this.questionData.length - 1;
        }
        let ans:Translations = this.languages.map(lang => {
            let tr: Translation = {
                LanguageId: lang.Id,
                Text: ''
            };
            return tr;
        })
        let ga : GivenAnswer = {
            Answer: ans,
            ChoiceId: undefined,
            MultipleChoiceAnswerList: ''
        };
        let qq:Translations = this.languages.map((lang, qx) => {
            let tr: Translation = {
                LanguageId: lang.Id,
                Text: qx === this.selectedLanguageIndex ? 'New Question' : ''
            };
            return tr;
        })                
        let nq : RiskProfileQuestionsModel = {
            Id: null,
            Answer: ga,
            Choices: [],
            Question: qq,
            QuestionType: questionTypes.UNDEFINED,
            RiskProfileId: this.riskProfiles[this.selectedProfileIndex].Id,
            MultipleChoice: false
        };       
        this.questionData.splice(questionIndex + 1, 0, nq);
        this.selectedQuestionIndex = questionIndex + 1;
    }

    addStrategy () {
        let ns:RiskProfileStrategy = cloneDeep(this.newStrategy);
        this.editedStrategies.push(ns);
        this.prepareNewStrategy();
    }

    removeStrategy (strategyIndex) {
        this.editedStrategies.splice(strategyIndex, 1);
    }

    fillOtherAnswers (questionIndex) {
        if (questionIndex === undefined) {
            return;
        }
        // by default when you enter an answer you enter it only for a single language
        // this will put the first found text in other languages
        let firstFilledAnswer = this.questionData[questionIndex].Answer.Answer.find(q => q.Text !== '' && q.Text !== null && q.Text !== undefined);
        if (firstFilledAnswer) {
            this.questionData[questionIndex].Answer.Answer.forEach(q => {
                if (q !== firstFilledAnswer && (q.Text === '' || q.Text === null || q.Text === undefined)) {
                    q.Text = firstFilledAnswer.Text;
                }
            })
        }        
    }

    fillOtherLanguages (questionIndex) {
        if (questionIndex === undefined) {
            return;
        }
        // by default when you enter a question/answer you enter it only for a single language
        // this will put the first found text in other languages        
        this.fillOtherAnswers(questionIndex);
        let firstFilledQuestion = this.questionData[questionIndex].Question.find(q => q.Text !== '' && q.Text !== null && q.Text !== undefined);
        if (firstFilledQuestion) {
            this.questionData[questionIndex].Question.forEach(q => {
                if (q !== firstFilledQuestion && (q.Text === '' || q.Text === null || q.Text === undefined)) {
                    q.Text = firstFilledQuestion.Text;
                }
            })
        }
        this.questionData[questionIndex].Choices.forEach(choice => {
            let firstFilledChoice = choice.Answer.find(q => q.Text !== '' && q.Text !== null && q.Text !== undefined);
            if (firstFilledChoice) {
                choice.Answer.forEach(q => {
                    if (q !== firstFilledChoice && (q.Text === '' || q.Text === null || q.Text === undefined)) {
                        q.Text = firstFilledChoice.Text;
                    }
                })
            }            
        })
        this.editedStrategies.forEach(strategy => {
            let firstFilledStrategy = strategy.Strategy.find(q => q.Text !== '' && q.Text !== null && q.Text !== undefined);
            if (firstFilledStrategy) {
                strategy.Strategy.forEach(q => {
                    if (q !== firstFilledStrategy && (q.Text === '' || q.Text === null || q.Text === undefined)) {
                        q.Text = firstFilledStrategy.Text;
                    }
                })
            } 
            let firstFilledStrategyDesc = strategy.Description.find(q => q.Text !== '' && q.Text !== null && q.Text !== undefined);
            if (firstFilledStrategyDesc) {
                strategy.Description.forEach(q => {
                    if (q !== firstFilledStrategyDesc && (q.Text === '' || q.Text === null || q.Text === undefined)) {
                        q.Text = firstFilledStrategyDesc.Text;
                    }
                })
            }            
                       
        })

    }

    nextQuestion () {
        if (this.editMode === editModes.ADMIN) {
            this.fillOtherLanguages(this.selectedQuestionIndex);
        }
        if (this.editMode !== editModes.ADMIN && this.selectedQuestionIndex === this.questionData.length - 1) {
            this.fillOtherAnswers(this.selectedQuestionIndex);
            this.calculatePoints();
            this.finishAssessment();                
        }
        if (this.selectedQuestionIndex < this.questionData.length - 1) {
            this.fillOtherAnswers(this.selectedQuestionIndex);
            this.prepareNewChoice();            
            this.selectedQuestionIndex++;
            this.calculatePoints();            
        }
    } 
    
    getResultById (resultId) : RiskProfileAssessmentModel {
        // console.log('getResultById ' + resultId)
        if (this.selectedProfileIndex > -1) {
            return this.riskProfiles[this.selectedProfileIndex].Assessments.find(r => r.Id === resultId);            
        } else {
            return;
        }
    }

    setFrozen (resultId: number = null) {
        this.editedResult = cloneDeep(this.getResultById(resultId));
        this.editedResult.Frozen = true;
        this.saveEditedResult();        
    }

    showChangeStrategyDialog (resultId: number = null) {
        if (this.getResultById(resultId).Frozen === false) {
            this.editedResult = cloneDeep(this.getResultById(resultId));
        }
    }

    saveEditedResult () {
        // console.log(this.questionData)
        let riskAssesmentData : RiskAssesmentDataModel = {
            riskProfileId: this.riskProfiles[this.selectedProfileIndex].Id,
            assessment: this.editedResult,
            questions: this.questionData
        }
        // console.log(riskAssesmentData);
        return this._riskService.updateRiskAssessment(riskAssesmentData).then(data => {
            // newly created record is in the body as the single assessment of only profile
            let rec:RiskProfileModel = JSON.parse(data['_body'])[0];
            let ix = this.riskProfiles[this.selectedProfileIndex].Assessments.findIndex(a => a.Id === rec.Assessments[0].Id);
            // delete old version and put new in place
            this.riskProfiles[this.selectedProfileIndex].Assessments.splice(ix, 1, rec.Assessments[0]);
            this.riskProfiles[this.selectedProfileIndex].CanEdit = false;
            this.refreshGrid();
        }).catch(err => {
            console.log(err);
        })
    }

    saveStrategyChange () {
        if (!this.editedResult.Frozen) {
            // save strategy name based on ID
            this.editedResult.Categories.forEach(cat => {
                cat.ChosenStrategy.Id = +cat.ChosenStrategy.Id;
                let findStrategy = this.riskProfiles[this.selectedProfileIndex].Strategies.find(s => s.Id === cat.ChosenStrategy.Id);
                if (findStrategy) {
                    cat.ChosenStrategy.Strategy = findStrategy ? findStrategy.Strategy : null;                              
                } else {
                    cat.ChosenStrategy.Id = null;
                    cat.ChosenStrategy.Strategy = null;                     
                }
            })
            this.saveEditedResult().then(() => {
                // cleanup
                this.cancelChangeStrategy();        
            });
        }
    }

    cancelDeleteAssessment () {
        this.editedResult = undefined;
    }

    cancelChangeStrategy () {
        // console.log('cancel');
        this.availableCategories = [];
        this.editedResult = undefined;
    }

    // go directly to the results page in the middle of questionnaire
    finishAssessment () {
        // calculation
        this.calculatePoints();
        this.changeViewState(viewStates.ASSESSMENT_RESULTS);
    }

    showDeleteAssessmentDialog (resultId) {
        if (this.getResultById(resultId).Frozen === false) {
            this.editedResult = cloneDeep(this.getResultById(resultId));
        }
    }

    deleteAssessment (resultId) {
        // TODO: what if manager prints the report, gives it to customer and then deletes it?
        // TODO: add some flag 'isPrinted' and prevent deletion?
        if (this.getResultById(resultId).Frozen === false) {
            this._riskService.deleteRiskAssessment(resultId).then(() => {
                let ix = this.riskProfiles[this.selectedProfileIndex].Assessments.findIndex(a => a.Id == resultId);
                this.riskProfiles[this.selectedProfileIndex].Assessments.splice(ix, 1);
                this.refreshGrid();
                this.cancelDeleteAssessment();
            });
        }
    }    
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-risk-assessment/riskAssessment.component.ts